import { shiptimeConstants } from '../constants';
import { shiptimeService } from '../../services';

export const shiptimeActions = {
  shiptimesList,
  addShiptime,
  getShiptime,
  updateShiptime
}

/*
ACTION: Shiptimes List
*/
function shiptimesList(addToast, pageID, perPage) {
  return dispatch => {
    dispatch(request());
    return shiptimeService.shiptimesList(pageID, perPage)
      .then(
        response => {
          dispatch(success(response.data.body.submission_times, response.data.body.total));
        },
        error => {
          if(typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: shiptimeConstants.GETALL_REQUEST } }
  function success(items, total) { return { type: shiptimeConstants.GETALL_SUCCESS, items, total } }
  function failure(error) { return { type: shiptimeConstants.GETALL_FAILURE, error } }
}

/*
ACTION: Add Shiptime
*/
function addShiptime(addToast, formData) {
  return dispatch => {
    dispatch(request());
    return shiptimeService.addShiptime(formData)
      .then(
        response => {
          addToast('عملیات با موفقیت انجام شد.', { appearance: "success", autoDismiss: true });
          dispatch(success(true));
        },
        error => {
          if(typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: shiptimeConstants.ADD_REQUEST } }
  function success(status) { return { type: shiptimeConstants.ADD_SUCCESS, status } }
  function failure(error) { return { type: shiptimeConstants.ADD_FAILURE, error } }
}

/*
ACTION: Get Shiptime By ID
*/
function getShiptime(addToast, shiptimeID) {
  return dispatch => {
    dispatch(request());
    return shiptimeService.getShiptime(shiptimeID)
      .then(
        response => {
          dispatch(success(response.data.body));
        },
        error => {
          if(typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: shiptimeConstants.GET_REQUEST } }
  function success(item) { return { type: shiptimeConstants.GET_SUCCESS, item } }
  function failure(error) { return { type: shiptimeConstants.GET_FAILURE, error } }
}

/*
ACTION: Update Shiptime
*/
function updateShiptime(addToast, formData) {
  return dispatch => {
    dispatch(request());
    return shiptimeService.updateShiptime(formData)
      .then(
        response => {
          addToast('بروزرسانی با موفقیت انجام شد.', { appearance: "success", autoDismiss: true });
          dispatch(success(true));
        },
        error => {
          if(typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: shiptimeConstants.UPDATE_REQUEST } }
  function success(status) { return { type: shiptimeConstants.UPDATE_SUCCESS, status } }
  function failure(error) { return { type: shiptimeConstants.UPDATE_FAILURE, error } }
}